import {
  getDownloadURL,
  getStorage,
  ref as storageRef,
} from "firebase/storage";
import { useEffect, useState } from "react";

export const useImageUrl = (path: string | null | undefined) => {
  const [imageUrl, setImageUrl] = useState<string>();

  useEffect(() => {
    const fetchImageUrl = async () => {
      if (path) {
        const storage = getStorage();
        const tempStorageRef = storageRef(storage, path);
        try {
          const url = await getDownloadURL(tempStorageRef);
          setImageUrl(url);
        } catch (error) {
          console.error("Error fetching image URL:", error);
        }
      }
    };

    fetchImageUrl();
  }, [path]);

  return imageUrl;
};
